export default __webpack_public_path__ + "static/media/ian-shuttleworth.9b274ebe.png";